import ComponentName from '@Constant/componentName'
import { HELP_MARK } from '@Constant/behaviorTrack'

const home = [
  {
    component: () => import('../../views/layout/HelpLayout/HelpLayout.vue'),
    path: '/help',
    children: [
      {
        component: () => import('../../views/help/Index.vue'),
        path: 'index',
        name: ComponentName.help.index,
        auth: '*',
        meta: {
          title: '帮助中心',
          logAuto: {
            pv: true,
            duration: true,
            source: HELP_MARK.PV,
            // reportQuery 支持函数or数组
            reportQuery: params => {
              const result = {}
              if (!params.domain || params.domain === 'ad-v2') {
                result.role = 3
              } else if (params.domain === 'mcn-v2') {
                result.role = 2
              } else if (params.domain === 'up-v2') {
                result.role = 1
              }

              return result
            }
          }
        }
      },
      {
        component: () => import('../../views/help/Detail.vue'),
        path: 'detail/',
        name: ComponentName.help.detail,
        auth: '*',
        meta: {
          title: '帮助详情',
          logAuto: {
            pv: true,
            duration: true,
            source: HELP_MARK.DETAIL_PV,
            reportQuery: params => {
              const result = {}

              if (!params.domain || params.domain === 'ad-v2') {
                result.role = 3
              } else if (params.domain === 'mcn-v2') {
                result.role = 2
              } else if (params.domain === 'up-v2') {
                result.role = 1
              }

              result.id = params.id
              result.title = params.title

              return result
            }
          }
        }
      },
      {
        component: () => import('../../views/help/Search.vue'),
        path: 'search',
        name: ComponentName.help.search,
        auth: '*',
        meta: {
          title: '搜索'
        }
      }
    ]
  }
]

export default home
